import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthContext from '../AuthContext';
import { LanguageContext } from '../LanguageContext';
import NotificationSettingsPanel from './NotificationSettingsPanel';
import styles from './NotificationSettingsPanel.module.css';

const UserSettingsPage = () => {
  const { authToken } = useContext(AuthContext);
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken) {
      navigate('/login');
    }
  }, [authToken, navigate]);

  return (
    <div style={{ minHeight: '100vh', background: '#ecf0f1', padding: '18px' }}>
      <div style={{ maxWidth: '1360px', margin: '0 auto' }}>
        <div className={styles.actions} style={{ marginBottom: '16px', justifyContent: 'space-between' }}>
          <h1 style={{ margin: 0, color: '#1f2f3d' }}>{t('notificationSettings')}</h1>
          <button className={styles.button} type="button" onClick={() => navigate('/dashboard')}>
            {t('dashboard')}
          </button>
        </div>
        <NotificationSettingsPanel />
      </div>
    </div>
  );
};

export default UserSettingsPage;
